<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/TOTOMj/cover.jpeg?1684571221910" alt="This image is the cover for the book My Contractual Ghost Husband, Volume 5"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">My Contractual Ghost Husband, Volume 5
      </h1>
      <p class="bookDescription body article font2">
        <p>When she woke up, she found that she was somehow involved in a series of bizarre events …</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chi AnYu, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03f00372